export class Factuur {
    ID : number;
    ObjectID : number
    ;FaktuurNummer :number
    ;FaktuurSerieNr :number
    ;FaktuurDatum :string
    ;VerkoopCorrGulden : number
    ;VerkoopCorrEuro : number
    ;VerkoopCorrExGulden : number
    ;VerkoopCorrExEuro : number
    ;TotaalBedragGulden : number
    ;TotaalBedragEuro : number
    ;Opmerking : string
    ;InvoerDatum : string
    ;MutatieDatum : string;
    Objectnummer : string;
}

export class  FactuurInfo {
            ID : number;
            FactuurID : number
           ;BedrijfNummer : number
           ;Toelichting : string
           ;StatusCodeID : number
           ;KostenGulden : number
           ;KostenEuro : number
           ;InvoerDatum: string
           ;MutatieDatum: string;
           ;IsCorrectie : number;
}

export class FactuurObject {
  ID: number;
  FactuurNummer : number;
  ObjectID: number;
  ObjectNummer: number;
  ObjectSerieNr:number;
  Contactpersoon:number;
  BedrijfNummer:number;
}


export class FactuurSelect {
  objectNR: string;
  factuurNR: string;
}


export class StatusCode {

ID: number
;StatusCode: string;
;CodeOmschrijving
;Volgorde: number
;IsCorrectie: boolean
;InvoerDatum: string;
;MutatieDatum: string;

}
